import React from 'react';
import PropTypes from 'prop-types';

import { StyledButton, ButtonText } from './styles';

const Button = ({ children, ...props }) => (
  <StyledButton {...props}>
    <ButtonText>{children}</ButtonText>
  </StyledButton>
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Button;
